import { useState, useEffect } from 'react';
import { Image } from '../../types';
import { downloadBlobDataByURLs, FILE_TYPES } from '../../utils/blobUtils';

// Uses same downloadBlobDataByURLs utility as StopImagesDialog and utils.js
export const useBlobImages = (images: Image[]) => {
  const [loadedImages, setLoadedImages] = useState<Record<string, string>>({});
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    if (images.length === 0) {
      setLoadedImages({});
      setFetchError(false);
      return;
    }

    const loadImages = async () => {
      const imageMap: Record<string, string> = {};
      setFetchError(false);

      // Filter blob storage URLs
      const blobUrls = images.filter(img =>
        img.url && img.url.startsWith('http') && !img.url.startsWith('data:')
      );

      if (blobUrls.length > 0) {
        try {
          // Use same utility as StopImagesDialog
          const imageURLs = blobUrls.map((img, index) => ({
            key: img.id || index.toString(),
            url: img.url
          }));

          const fetchedImages = await downloadBlobDataByURLs(imageURLs);

          // Map fetched images back to their IDs
          fetchedImages.forEach((fetchedImg, index) => {
            const originalImg = blobUrls[index];
            if (originalImg) {
              imageMap[originalImg.id] = `${FILE_TYPES.IMAGE}${fetchedImg.blobData}`;
            }
          });
        } catch (error) {
          setFetchError(true);
        }
      }

      // Add non-blob URLs (data URLs, etc.)
      images.forEach(img => {
        if (!imageMap[img.id]) {
          imageMap[img.id] = img.url;
        }
      });

      setLoadedImages(imageMap);
    };

    loadImages();
  }, [images]);

  return { loadedImages, fetchError };
};
